import { FC, ReactNode } from "react"
import styled from "@emotion/styled"

export interface ErrorMessageProps {
    children?: ReactNode
}

const ErrorMessageContainer = styled.div`
    width: 100%;
`;

const ErrorMessageText = styled.p`
    color: #a83a3a;
    text-align: center;
    padding: 8px 12px;
    font-size: 14px;
    border-radius: 10px;
    margin-bottom: 5px;
    font-family: "EBENYA", sans-serif;
    letter-spacing: 2px;
    background: rgba(232, 94, 94, 0.12);
    border: 1px solid rgba(232, 94, 94, 0.35);
`

export const ErrorMessage: FC<ErrorMessageProps> = (props) => {
    return <ErrorMessageContainer>
        <ErrorMessageText>
            {props.children}
        </ErrorMessageText>
    </ErrorMessageContainer>
}
